import { stringify } from "../api/queryString";
import { getSelectedSearchOption } from "../filters/selectors";
import { getCurrentPage, getFilterLookup, getSortBy, getSearchSettings, getLocation } from "../search/selectors";
import SearchUrl from "../search/SimpleUrl";
import { isPaginatingByLoadMore } from "../results/selectors";
let canonicalTag = null;

const createCanonical = url => {
  const { protocol, hostname, port = null } = window.location;
  canonicalTag = canonicalTag || document.querySelector('link[rel="canonical"]');
  const canonicalUrl =  `${protocol}//${hostname}${port ? `:${port}` : ""}${url}`;
  if (!canonicalTag) {
    const head = document.querySelector("head");
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = canonicalUrl;
    canonicalTag = link;
    head.appendChild(link);
  } else {
    canonicalTag.href = canonicalUrl;
  }
}

const getOtherQueryStringParams = (state, filters) => {
  const  location = getLocation(state);

  return location && location.query && Object.keys(location.query)
    .filter((key) => !Object.keys(filters).includes(key))
    .filter((key) => key !== state.filters.data.searchOptionKey)
    .reduce((obj, key) => {
      return Object.assign(obj, {
        [key]: location.query[key],
      });
    }, {});
}

export const browserHistoryMiddleware = history => store => next => action => {
  next(action);
  const state = store.getState();

  if (action.meta && action.meta.updateQueryString) {
    const searchOption = getSelectedSearchOption(state);

    const {
      pageUrl = "/search",
      routes,
      defaultUrl,
    } = getSearchSettings(state);
    const simpleUrl = new SearchUrl(routes, pageUrl, defaultUrl);
    const page = getCurrentPage(state);
    const isLoadMore = isPaginatingByLoadMore(state);
    const addPageNumber = !isLoadMore || action.meta.resetPagination;
    const sortBy = getSortBy(state);

    const sort = {
      [sortBy.key]: [sortBy.value],
    };

    const getSimpleUrl = filters => {
      const searchBy = searchOption.key;
      const url = simpleUrl.getUrl(filters, searchBy);
      return url;
    };

    const filters = getFilterLookup(state);
    const newParams = {};

    const otherParams = getOtherQueryStringParams(state, filters);

    const newFilters = simpleUrl.getQueryString(filters, searchOption);
    const url = getSimpleUrl(filters);

    const updatedParams = {
      ...newParams,
      ...newFilters,
      ...otherParams,
      ...sort,
      page: addPageNumber && page > 1 ? page.toString() : "",
    };

    const updated = Object.keys(updatedParams)
      ? stringify(
          Object.entries(updatedParams).reduce((result, [key, value]) => {
            value = Array.isArray(value) ? value.join(",") : value;
            return { ...result, [key]: value.toLowerCase() };
          },
          {}),
        )
      : null;

    const newUrl = `${url.replaceAll('%20',"-").replaceAll(' ',"-").toLowerCase()}${updated && `?${updated}`}`;
      createCanonical(newUrl);

    if (action.meta.replaceState) {
      window.history.replaceState({}, "", newUrl);
    } else {
      window.history.pushState({}, "", newUrl);
    }
  }
};
